// [BD feat] Signup Success — bd-signup-success.js
// Shows the success state after a Klaviyo sign-up. Hook = the wave-2 signup form: it dispatches
// `bd:signup:success` (bubbles, detail {email, section, form}) once Klaviyo accepted the profile.
// The state takes over the page (body.bd-signup-success-active hides the other sections + footer),
// scrolls to the top and moves focus to the heading. ?bd_signup=success opens it without a submit
// (QA / previews); in the theme editor selecting the section opens it, deselecting closes it.
(function () {
  'use strict';

  var ACTIVE = 'bd-signup-success-active';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function sections() {
    return [].slice.call(document.querySelectorAll('[data-bd-signup-success-section]'));
  }

  function activate(section) {
    if (!section) return;
    section.hidden = false;
    document.body.classList.add(ACTIVE);
    window.scrollTo({ top: 0, left: 0, behavior: reduced ? 'auto' : 'auto' });
    var heading = section.querySelector('[data-bd-signup-success-heading]');
    var target = heading || section;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  function deactivate(section) {
    if (!section) return;
    section.hidden = true;
    document.body.classList.remove(ACTIVE);
  }

  function first() {
    var all = sections();
    return all.length ? all[0] : null;
  }

  document.addEventListener('bd:signup:success', function () {
    activate(first());
  });

  // Preview / QA entry: ?bd_signup=success (no subscription is made)
  try {
    if (new URLSearchParams(window.location.search).get('bd_signup') === 'success') activate(first());
  } catch (e) { /* URLSearchParams unavailable — the event path still works */ }

  // Shopify theme editor
  document.addEventListener('shopify:section:select', function (e) {
    var s = e.target && e.target.querySelector ? e.target.querySelector('[data-bd-signup-success-section]') : null;
    if (s) activate(s);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var s = e.target && e.target.querySelector ? e.target.querySelector('[data-bd-signup-success-section]') : null;
    if (s) deactivate(s);
  });
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector ? e.target.querySelector('[data-bd-signup-success-section]') : null;
    if (s && document.body.classList.contains(ACTIVE)) activate(s);
  });
})();
// [BD feat] Signup Success
